import * as yup from "yup";

import { CA_POSTCODE_REGEX, isPostalCodeRequired, isStateRequired, US_ZIPCODE_REGEX } from "./addressUtils";
import { CA_PROVINCES_REGEX, US_STATES_REGEX } from "./states";

export const yupValidatePostalCode = (countryField: string) =>
    yup
        .string()
        .when(countryField, {
            is: "US",
            then: (schema) => schema.required().matches(US_ZIPCODE_REGEX, "ZIP code is invalid"),
        })
        .when(countryField, {
            is: "CA",
            then: (schema) => schema.required().matches(CA_POSTCODE_REGEX, "Postal code is invalid"),
        })
        .when(countryField, {
            is: (countryCode: string) => (countryCode ? isPostalCodeRequired(countryCode) : false),
            then: (schema) => schema.required(),
        });

export const yupValidateState = (countryField: string) =>
    yup
        .string()
        .when(countryField, {
            is: "US",
            then: (schema) => schema.required().matches(US_STATES_REGEX, "State is invalid"),
        })
        .when(countryField, {
            is: "CA",
            then: (schema) => schema.required().matches(CA_PROVINCES_REGEX, "Province is invalid"),
        })
        .when(countryField, {
            is: (countryCode: string) => (countryCode ? isStateRequired(countryCode) : false),
            then: (schema) => schema.required(),
        })
        .test({
            message: "State must be valid",
            test: (value, _ctx) => !onlyContainsNumbers(value ?? ""),
        });

export const onlyContainsNumbers = (fieldValue: string) => {
    return /^\d+$/.test(fieldValue);
};
